
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as beispielobjekt_45juwel_dm0fkDuws9cHPWAfwdFKMep66iKGj4hEZJFONccogEMeta } from "/home/snaumann/Development/public_html/konspirative-wohnungen-leipzig/public/app/pages/beispielobjekt-juwel.vue?macro=true";
import { default as datenschutzho8F_gx0q0Cv4FRq3_YM7g4dfpmb4KEWGiXWSgmUYE0Meta } from "/home/snaumann/Development/public_html/konspirative-wohnungen-leipzig/public/app/pages/datenschutz.vue?macro=true";
import { default as feldbeschreibungenNFlm4jXcMgMZDfxn_HGu_Ogpm6m8LgUiXQZse5jGQQMMeta } from "/home/snaumann/Development/public_html/konspirative-wohnungen-leipzig/public/app/pages/feldbeschreibungen.vue?macro=true";
import { default as impressumylhjmL4rCxpMJYNCYFXIwPtiOzGvpRSJjXT57_6GiqoMeta } from "/home/snaumann/Development/public_html/konspirative-wohnungen-leipzig/public/app/pages/impressum.vue?macro=true";
import { default as projektbeschreibungstUrokWlZ6ET0xZYSQTGHXgOpidXa8gNLP05DXYAALYMeta } from "/home/snaumann/Development/public_html/konspirative-wohnungen-leipzig/public/app/pages/projektbeschreibung.vue?macro=true";
import { default as index4FbcEy755yskdoOgqwXhyys31Yw_WN4jvNhyt1TfSVoMeta } from "/home/snaumann/Development/public_html/konspirative-wohnungen-leipzig/public/app/pages/index.vue?macro=true";
export default [
  {
    name: "beispielobjekt-juwel",
    path: "/beispielobjekt-juwel",
    component: () => import("/home/snaumann/Development/public_html/konspirative-wohnungen-leipzig/public/app/pages/beispielobjekt-juwel.vue").then((m) => Object.assign(m.default, { __name: beispielobjekt_45juwel_dm0fkDuws9cHPWAfwdFKMep66iKGj4hEZJFONccogEMeta?.name ?? "beispielobjekt-juwel" }))
  },
  {
    name: "datenschutz",
    path: "/datenschutz",
    component: () => import("/home/snaumann/Development/public_html/konspirative-wohnungen-leipzig/public/app/pages/datenschutz.vue").then((m) => Object.assign(m.default, { __name: datenschutzho8F_gx0q0Cv4FRq3_YM7g4dfpmb4KEWGiXWSgmUYE0Meta?.name ?? "datenschutz" }))
  },
  {
    name: "feldbeschreibungen",
    path: "/feldbeschreibungen",
    component: () => import("/home/snaumann/Development/public_html/konspirative-wohnungen-leipzig/public/app/pages/feldbeschreibungen.vue").then((m) => Object.assign(m.default, { __name: feldbeschreibungenNFlm4jXcMgMZDfxn_HGu_Ogpm6m8LgUiXQZse5jGQQMMeta?.name ?? "feldbeschreibungen" }))
  },
  {
    name: "impressum",
    path: "/impressum",
    component: () => import("/home/snaumann/Development/public_html/konspirative-wohnungen-leipzig/public/app/pages/impressum.vue").then((m) => Object.assign(m.default, { __name: impressumylhjmL4rCxpMJYNCYFXIwPtiOzGvpRSJjXT57_6GiqoMeta?.name ?? "impressum" }))
  },
  {
    name: "projektbeschreibung",
    path: "/projektbeschreibung",
    component: () => import("/home/snaumann/Development/public_html/konspirative-wohnungen-leipzig/public/app/pages/projektbeschreibung.vue").then((m) => Object.assign(m.default, { __name: projektbeschreibungstUrokWlZ6ET0xZYSQTGHXgOpidXa8gNLP05DXYAALYMeta?.name ?? "projektbeschreibung" }))
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/snaumann/Development/public_html/konspirative-wohnungen-leipzig/public/app/pages/index.vue").then((m) => Object.assign(m.default, { __name: index4FbcEy755yskdoOgqwXhyys31Yw_WN4jvNhyt1TfSVoMeta?.name ?? "index" }))
  }
]